<app-top-navigation backLinkPath="/">
  <span title>Histórico de importação</span>
</app-top-navigation>
<aside
  class="sidebar-processing-status-protocol"
  #container
  [ngClass]="{'slide-menu-active': showSidebar}"
  (click)="toggleMenu()"
>
  <div
    (click)="$event.stopImmediatePropagation();"
    class="sidebar-processing-status-protocol-wrapper-menu"
    [ngClass]="{'wrapper-menu-active': showSidebar}"
  >
    <div class="sidebar-processing-status-protocol-menu">
      <div class="header-sidebar">
        <p>Informações do arquivo</p>
        <button type="button" aria-label="Fecha menu lateral" (click)="toggleMenu()"></button>
      </div>
      <div *ngIf="statusProtocol$ | async as statusProtocol else loading">
        <ul class="sidebar-content">
          <li>
            <p class="sidebar-content__label">
              Nome do arquivo
            </p>
            <p class="sidebar-content__title">
              {{statusProtocol?.originalName}}
            </p>
          </li>
          <li>
            <p class="sidebar-content__label">Data e hora do envio</p>
            <p class="sidebar-content__title">
              {{statusProtocol?.createdAt | date: 'dd/MM/yyyy'}} as
              {{statusProtocol?.createdAt | date: 'shortTime'}}
            </p>
          </li>
          <li>
            <p class="sidebar-content__label">Colaboradores importados</p>
            <p class="sidebar-content__title">
              {{statusProtocol?.importedRegisterCount}}
            </p>
          </li>
          <li>
            <p class="sidebar-content__label">Protocolo</p>
            <p class="sidebar-content__title">
              {{statusProtocol?.protocolNumber}}
            </p>
          </li>
          <li>
            <p class="sidebar-content__label">Status</p>
            <p class="sidebar-content__title">
              <span
                *ngIf="statusProtocolLabel(statusProtocol?.status)"
                class="list-processing-status-label"
                [ngClass]="statusProtocolLabel(statusProtocol?.status).class"
              >
                {{ statusProtocolLabel(statusProtocol?.status)?.message }}
              </span>
            </p>
          </li>
          <li>
            <p class="sidebar-content__label">Tamanho do arquivo</p>
            <p class="sidebar-content__title">
              {{statusProtocol?.FileSizeInBytes}}
            </p>
          </li>
          <div *ngIf="statusProtocol?.status === 'FINISHED_WITH_ERRORS'">
            <a>
              <button
                class="btn-import-collaborators download"
                aria-label="Abre menu lateral status de importação"
                id="open-sidebar-status"
                type="button"
                (click)="downloadStatusError(statusProtocol.protocolNumber)"
              >
                Exportar relatório de erros
                <span></span>
              </button>
            </a>
          </div>
        </ul>
      </div>
      <ng-template #loading>
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </ng-template>
    </div>
  </div>
</aside>
<div class="processing-status-container">
  <div *ngIf="list$ | async as lists else loadingUpload;">
    <div class="processing-status-header">
      <p>Todos os arquivos</p>
      <a
        *ngIf="lists?.length"
        routerLink="/new"
        type="button"
        data-test="btnImportListEmpty"
        class="btn-import-collaborators import"
        (click)="trackHistory('import_history')"
      >
        Importar colaboradores
      </a>
    </div>
    <ng-container *ngIf="lists?.length; else emptyList;">
      <table mat-table [dataSource]="lists | paginate: { id: 'server', itemsPerPage: limit, currentPage: page, totalItems: total }">
        <ng-container matColumnDef="fileName">
          <th mat-header-cell *matHeaderCellDef> Nome do arquivo </th>
          <td mat-cell *matCellDef="let element" class="list-processing-status">
            <p>{{element?.originalName}}</p>
          </td>
        </ng-container>
      
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef> Data e hora do envio </th>
          <td mat-cell *matCellDef="let element"> {{element?.createdAt | date: 'dd/MM/yyyy'}} as {{element?.createdAt | date: 'shortTime'}} </td>
        </ng-container>

        <ng-container matColumnDef="imported">
          <th mat-header-cell *matHeaderCellDef> Colaboradores importados </th>
          <td mat-cell *matCellDef="let element"> {{element?.importedRegisterCount}} </td>
        </ng-container>

        <ng-container matColumnDef="protocol">
          <th mat-header-cell *matHeaderCellDef> Protocolo </th>
          <td mat-cell *matCellDef="let element"> {{element?.protocolNumber}} </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Status </th>
          <td mat-cell *matCellDef="let element"> 
            <span
              *ngIf="statusProtocolLabel(element?.status)"
              class="list-processing-status-label"
              [ngClass]="statusProtocolLabel(element?.status).class"
            >
              {{ statusProtocolLabel(element?.status)?.message }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Ações </th>
          <td mat-cell *matCellDef="let element"> 
            <button
              class="button-open-menu"
              aria-label="Abre menu lateral status de importação"
              id="open-sidebar-status"
              type="button"
              (click)="statusProcessingProtocol(element?.protocolNumber)"
            >
            </button>
          </td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </ng-container>

    <ng-template #emptyList>
      <div class="processing-status-empty-container">
        <div class="processing-status-empty-content">
          <p class="processing-status-empty-content__title">
            Não há nenhuma importação
          </p>
          <p class="processing-status-empty-content__subtitle">
            Importe uma lista de colaboradores clicando no botão abaixo.
          </p>
          <a
            routerLink="/new"
            type="button"
            data-test="btnImportListEmpty"
            class="btn-import-collaborators import"
            (click)="trackHistory('import_empty')"
            >
            Importar colaboradores
          </a>
        </div>
      </div>
    </ng-template>
  </div>
</div>
<div>
  <up-feature-pagination
    [newBrand]="true"
    [limit]="limit"
    [total]="total"
    (pageChange)="getPage($event)"
    (limitChange)="getPageForLimit($event)"
  ></up-feature-pagination>
</div>
<ng-template #loadingUpload>
  <div *ngIf="error$ | async as error; else loading" class="home-loading error-loading">
    <up-feature-status-error [code]="error?.status"></up-feature-status-error>
  </div>
  <ng-template #loading>
    <div class="home-loading">
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </ng-template>
</ng-template>
